
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StackedForm from '../../mixins/StackedForm';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import CustomerGroup from '@/mixins/CustomerGroup';
import { Article } from '@/interfaces/models/Article';
import { venueFilter } from '@/util/helper';

@Component({
  components: { VFormBuilder },
})
export default class ScreensaverUpsellForm extends mixins(StackedForm, CustomerGroup) {
  @Prop({ type: Array, required: true }) public articles!: Article[];

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any; getFilesToRemove: () => string[] };
  };

  get items() {
    return [
      {
        name: 'articles',
        type: InputType.Autocomplete,
        label: 'screensaver.form.articles',
        multiple: true,
        items: this.articleItems,
        useChips: true,
      },
    ];
  }

  get articleItems() {
    return this.articles.map((a: Article) => {
      return {
        value: a._id,
        text: `${this.$options.filters!.localized(a.name)} (${a.number})`,
      };
    });
  }
}
